module.exports = __webpack_public_path__ + "img/Active.0137f964.svg";